import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConfirmationOfApplication, PlaceOfResidencePreview } from '@/features/ui';
import { useProceedNextFromConfirmation } from '@/features/ui/Steps/ConfirmationOfApplication/utils/useProceedNextFromConfirmation';
import { PersonalAndPassportDataPreview } from '@/features/ui/Steps/PersonalAndPassportData';

import { ConditionView, StepControlPanel } from '@/shared/ui';

import { Loader } from '@/shared/ui';

import { ReapplicationMergedSchema } from '../../model/types';

import { ReapplicationDocumentsPreview } from './ReapplicationDocuments';

export interface DataPreviewProps {
  handleGeneratePDF: (formData: ReapplicationMergedSchema) => Promise<void>;
  shouldBeAbleToUpdateProfile: boolean;
}

export const DataPreview: React.FC<StepProps<DataPreviewProps>> = ({
  next,
  prev,
  handleGeneratePDF,
  shouldBeAbleToUpdateProfile,
}) => {
  const { getValues, watch } = useFormContext<ReapplicationMergedSchema>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { proceedNextFromConfirmation } = useProceedNextFromConfirmation(next);

  const confirmEnteredDataCorrect = watch('confirmEnteredDataCorrect');

  const handleNextStep = (): void => {
    setIsLoading(true);

    handleGeneratePDF?.(getValues())
      .then(proceedNextFromConfirmation)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  };

  return (
    <ConditionView if={!isLoading} else={<Loader />}>
      <FormBlock title="Підтвердження даних" className="form-block__data-preview">
        <PersonalAndPassportDataPreview />
        <PlaceOfResidencePreview />
        <ReapplicationDocumentsPreview />
      </FormBlock>
      <ConfirmationOfApplication
        updateProfileLabelElement="Я хочу додати/оновити свій профіль згідно даних, які введені в цьому запиті"
        shouldBeAbleToUpdateProfile={shouldBeAbleToUpdateProfile}
      />
      <StepControlPanel prev={prev} next={handleNextStep} disabledNext={!confirmEnteredDataCorrect} />
    </ConditionView>
  );
};
